@use 'sass:map';
@use 'ui/styles/core-tokens' as core;

.container {
  &Body {
    padding: 24px 24px 0 24px;
  }
}

.command {
  align-items: flex-start;
  display: flex;
  gap: 24px;

  &Field {
    margin: 0px;
    width: 80%;
  }

  &History {
    max-height: 200px;
    overflow-y: auto;
    background-color: map.get(core.$colors, lightGrey);
    padding: 16px 35px;
    border-radius: 2px;
    overflow-x: hidden;
    list-style: disc;
    margin-top: 16px;

    &::-webkit-scrollbar {
      -webkit-appearance: none;
      background-color: #eaf4f9;
      border-radius: 4px;
      width: 10px;
    }

    &::-webkit-scrollbar-thumb:vertical {
      background-color: map.get(core.$fonts, fontSecondaryDisabled);
      border: 1px solid map.get(core.$fonts, label);
      border-radius: 4px;
      height: 2px !important;
      width: 10px;
    }

    &Item {
      &Pre {
        margin: 0;
        white-space: pre-wrap;
        font-size: core.$m;
        font-family: 'Lato', sans-serif;
      }
    }
  }
}
